import { Component } from '@angular/core';

@Component({
    selector: 'app-header-payment',
    templateUrl: './header-payment.component.html',
    styleUrls: ['./header-payment.component.css'],
    standalone: false
})
export class HeaderPaymentComponent {

}
